import { createReducer } from 'redux-act';


import {
    CATEGORIES_FETCH_DATA_INIT,
    CATEGORIES_FETCH_DATA_SUCCESS,
    CATEGORIES_FETCH_DATA_FAIL,
    CATEGORIES_CREATE_CATEGORY_INIT,
    CATEGORIES_CREATE_CATEGORY_SUCCESS,
    CATEGORIES_CREATE_CATEGORY_FAIL,
    CATEGORIES_DELETE_CATEGORY_FAIL,
    CATEGORIES_DELETE_CATEGORY_SUCCESS,
    CATEGORIES_DELETE_CATEGORY_INIT,
    CATEGORIES_MODIFY_CATEGORY_FAIL,
    CATEGORIES_MODIFY_CATEGORY_INIT,
    CATEGORIES_MODIFY_CATEGORY_SUCCESS,
    CATEGORIES_CLEAN_UP
  } from 'state/actions/categories';
  
  const initialState = {
    data: [],
    loading: false,
    error: null,
    success: false,
    deleted: false,
  };

  
  export const categoriesReducer = createReducer(
    {
      [CATEGORIES_FETCH_DATA_INIT]: () => ({
        ...initialState,
        loading: true,
      }),
      [CATEGORIES_FETCH_DATA_SUCCESS]: (state, payload) => ({
        ...state,
        data: payload.data,
        loading: false,
        error: null,
      }),
      [CATEGORIES_FETCH_DATA_FAIL]: (state, payload) => ({
        ...state,
        loading: false,
        error: payload.error,
      }),
      [CATEGORIES_CREATE_CATEGORY_INIT]: (state) => ({
        ...state,
        loading: true,
      }),
      [CATEGORIES_CREATE_CATEGORY_SUCCESS]: (state, payload) => ({
        ...state,
        data: state.data.concat(payload.category),
        loading: false,
        error: null,
        success: true,
      }),
      [CATEGORIES_CREATE_CATEGORY_FAIL]: (state, payload) => ({
        ...state,
        loading: false,
        error: payload.error,
      }),
      [CATEGORIES_DELETE_CATEGORY_INIT]: (state) => ({
        ...state,
        loading: true,
      }),
      [CATEGORIES_DELETE_CATEGORY_SUCCESS]: (state, payload) => ({
        ...state,
        data: state.data.filter((elem) => elem.id !== payload.id),
        loading: false,
        error: null,
        deleted: true,
      }),
      [CATEGORIES_DELETE_CATEGORY_FAIL]: (state, payload) => ({
        ...state,
        loading: false,
        error: payload.error,
      }),
      [CATEGORIES_MODIFY_CATEGORY_INIT]: (state) => ({
        ...state,
        loading: true,
      }),
      [CATEGORIES_MODIFY_CATEGORY_SUCCESS]: (state, payload) => ({
        ...state,
        data: !state.data
          ? []
          : state.data.map((elem) => {
              if (elem.id === payload.id) {
                return {
                  name: payload.category.placeholder,
                  subcategories: payload.category.subcategories,
                  createdAt: payload.category.createdAt,
                };
              }
              return elem;
            }),
        loading: false,
        error: null,
        success: true,
      }),
      [CATEGORIES_MODIFY_CATEGORY_FAIL]: (state, payload) => ({
        ...state,
        loading: false,
        error: payload.error,
      }),
      [CATEGORIES_CLEAN_UP]: (state) => ({
        ...state,
        loading: false,
        error: null,
        success: false,
        deleted: false,
      }),
    },
    initialState
  );
  